<template>
	<div>
		<p>
			Es wurden alle offenen Fragen zwischen <b>{{ companyName }}</b> und <b>{{ applicantName }}</b> geklärt und
			Sie haben intern nun die Entscheidung gefällt, <b>{{ applicantName }}</b> jetzt eine verbindliche Zusage
			mitzuteilen. - Sollte ein schriftlicher Vertrag vorgesehen sein, so wird dieser noch unterschrieben werden.
		</p>
		<p><b>{{ applicantName }}, erhält folgende Nachricht von dir:</b></p>
		<InfoBox class="my-3" :with-icon="false" type="purple-lightest">
			<nl2br tag="div" :text="text"/>
		</InfoBox>
		<p>
			Sobald <b>{{ applicantName }}</b> ebenfalls Interesse mitteilt, erhältst du für die nächsten Schritte die
			Kontaktdaten von <b>{{ applicantName }}</b>, wie E-Mail Adresse und Mobilnummer.
		</p>
	</div>
</template>

<script>
import InfoBox from "@/vue/common/InfoBox";
import Nl2br from 'vue-nl2br'

export default {

	components: {
		InfoBox,
		Nl2br,
	},

	props: {
		applicantName: {
			type: String,
			required: true,
		},
		companyName: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			required: true,
		}
	}
}
</script>

